module.exports = __webpack_public_path__ + "static/img/PA.6d91b177.svg";